import md5 from 'js-md5'
import {
  doLoginApi,
  getCompanyByIdApi,
  getRoleFunctionListApi,
  getBrandListApi,
  getBrandByIdApi,
  getShopListApi,
  doLogoutApi,
  getRoleByIdApi,
  getCompanyCustomConfigApi,
  queryAgentCompanyApi,
  getShareShopListApi,
  getGroupByIdApi,
  queryAccountOutApi,
  getShopByIdApi
} from '@/api'
import { RES_OK } from '@/config'
import router from '@/router'
import { Loading, Message } from 'element-ui'
import { generatorMap, isEmpty } from '@/utils'
//   import Vue from 'vue'
//   import { userInfo } from 'os'
//   权限列表处理
let hasBrand = true
let functionAuthMap = ''
// let isOpenGxms = false
const handleMenuList = (list, getters) => {
  list.forEach(item => {
    item.isShow = true
    if (item.isCheckFunctionAuth === '1' && !isEmpty(item.funValue)) {
      if (!functionAuthMap[item.funValue]) {
        item.isShow = false
      }
    }
  })
  //  const { isCateringIndustry, hasZXKFAuth, hasLBYXAuth } = getters
  const parentList = list.filter(
    item =>
      item.useType !== 'SY' &&
      Number(item.parentId) === -1 &&
      Number(item.grade) === 1 &&
      item.type === 'menu' &&
      item.isShow
  )
  const sonList = list.filter(
    item =>
      Number(item.parentId) !== -1 &&
      Number(item.grade) === 2 &&
      item.type === 'menu' &&
      item.isShow
  )
  parentList.forEach(pItem => {
    sonList.forEach(sItem => {
      if (sItem.parentId === pItem.id) {
        //  如果没有就创建一个
        //  debugger
        if (!pItem.hasOwnProperty('children')) {
          pItem.children = []
        }
        pItem.children.push(sItem)
      }
    })
  })
  //  if (hasZXKFAuth) {
  //    parentList.push({
  //      id: 'ZXKF',
  //      cssClass: 'icon-group',
  //      name: '在线客服'
  //    })
  //  }
  return parentList
}
const actions = {
  //  登录
  async doLoginAction({ commit, dispatch }, { username, password, checked }) {
    const param = {}
    param.username = username
    param.password = md5(password).toUpperCase()
    const loading = Loading.service({
      lock: true,
      text: '拼命加载中...'
    })
    const res = await doLoginApi(param)
    if (checked) {
      localStorage.setItem('loginUser', param.username)
      localStorage.setItem('loginPassword', password)
    } else {
      // localStorage.setItem('loginUser', '')
      // localStorage.setItem('loginPassword', '')
      localStorage.removeItem('loginUser')
      localStorage.removeItem('loginPassword')
    }
    if (res.Code === RES_OK) {
      const result = res.Result || {}
      if (isEmpty(result.roleId)) {
        loading.close()
        Message.error({
          showClose: true,
          message: '请先配置角色权限',
          type: 'danger'
        })
        return
      }
      //  dispatch：含有异步操作，例如向后台提交数据，写法： this.$store.dispatch('mutations方法名',值)
      //  commit：同步操作，写法：this.$store.commit('mutations方法名',值)
      commit('setIsGSLogin', result.hierarchyType)
      commit('setLoginState', true)
      commit('setSysToken', res.Token)
      commit('setSysUid', res.Uid)
      commit('setUserInfo', result)
      await dispatch('getCompanyById')
      await dispatch('getRoleFunctionListActions')
      loading.close()
      Message.success({
        showClose: true,
        message: '登录成功',
        type: 'success'
      })
    } else {
      setTimeout(() => {
        loading.close()
      }, 500)
    }
  },
  //  登出
  async loginOutAction({ state, commit }) {
    //  Vue.$message({
    //    type: 'success',
    //    message: '退出成功!'
    //  })
    //  return
    const res = await doLogoutApi()
    if (res.Code === RES_OK) {
      Message.success({
        showClose: true,
        message: '退出成功',
        type: 'success'
      })
      await commit('setLoginState', false)
      setTimeout(async () => {
        // commit('setBrandInfo', {})
        // commit('setNavList', [])
        // commit('setOriginNavList', [])
        // commit('setLoginState', false)
        await window.sessionStorage.clear()
        //  这种方法不会 恢复state初始状态
        //  router.push({
        //    name: 'Login'
        //  })
        //  这种方法可以 恢复state初始状态
        window.location.reload()
      }, 1000)
    }
  },
  //  获取公司信息
  async getCompanyById({ getters, commit, dispatch }) {
    const param = {}
    param.id = getters.companyId
    const res = await getCompanyByIdApi(param)
    if (res.Code === RES_OK) {
      // let obj = res.Result
      // let businessMode = obj.businessMode || ''
      // if (!isEmpty(businessMode)) {
      //   businessMode = businessMode.split(',')
      //   isOpenGxms = businessMode.some(info => info === '6')
      // }
      commit('setOriginCompanyInfo', res.Result)
      commit('setCompanyInfo', res.Result)
      dispatch('doQueryAccountOutAction')
      if (res.Result.isHaveAgentAuth && res.Result.isHaveAgentAuth === '1') {
        dispatch('queryAgentCompany')
      }
    }
  },
  async doGetCompanyByIdAction({ getters, commit }) {
    const param = {}
    param.id = getters.companyId
    const res = await getCompanyByIdApi(param)
    if (res.Code === RES_OK) {
      commit('setOriginCompanyInfo', res.Result)
      commit('setCompanyInfo', res.Result)
      // dispatch('doQueryAccountOutAction')
      // if (res.Result.isHaveAgentAuth && res.Result.isHaveAgentAuth === '1') {
      //   dispatch('queryAgentCompany')
      // }
    }
  },
  //  获取权限信息
  async getRoleFunctionListActions({ commit, getters, dispatch }) {
    const param = {
      roleId: getters.userInfo.roleId,
      channelId: '100122'
    }
    await dispatch('getCompanyCustomConfig')
    //  如果是公司登录
    if (getters.isGSLogin) {
      await dispatch('doGetBrandList')
    } else {
      await dispatch('getBrandById', getters.userInfo.brandId)
    }
    if (!hasBrand) {
      router.push({
        path: '/'
      })
      Message.success({
        showClose: true,
        message: '请先初始化品牌信息',
        type: 'error'
      })
      return
    }
    const res = await getRoleFunctionListApi(param)
    if (res.Code === RES_OK) {
      let list = res.Result || []
      if (
        getters.userInfo.hierarchyType === 'MD'
        // ||
        // getters.userInfo.isInitCreat !== '1'
      ) {
        list = list.filter(info => info.id !== 'A834E8E9')
      }
      const navList = handleMenuList(list, getters)
      //  console.log(navList)

      commit('setNavList', navList)
      commit('setOriginNavList', list)
      let pathName = ''
      if (navList.length === 0) {
        pathName = '/'
      } else {
        let backMenuConfig = getters.backMenuConfig || []
        if (backMenuConfig.length > 0) {
          for (let i = 0; i < navList.length; i++) {
            let obj = navList[i]
            if (backMenuConfig.some(info => info.id === obj.id)) {
              if (obj.children && obj.children.length > 0) {
                let bool = false
                for (let j = 0; j < obj.children.length; j++) {
                  let chil = obj.children[j]
                  if (backMenuConfig.some(info => info.id === chil.id)) {
                    pathName = obj.url + '/' + chil.url
                    bool = true
                    break
                  }
                }
                if (bool) {
                  break
                }
                // pathName = obj.url + '/' + obj.children[0].url
                // break
              } else {
                pathName = obj.url
                break
              }
            }
          }
        } else {
          if (navList[0].children && navList[0].children.length > 0) {
            pathName = navList[0].url + '/' + navList[0].children[0].url
          } else {
            pathName = navList[0].url
          }
        }
      }
      let host = location.host
      if (host === 'syxf.hyunst.com') {
        pathName = '/'
      }
      router.push({
        // name: 'Home'
        path: pathName
      })
    }
  },
  async getCompanyCustomConfig({ commit, state, dispatch }) {
    let param = {}
    param.companyId = state.userInfo.companyId
    param.configType = ''
    const res = await getCompanyCustomConfigApi(param)
    if (res.Code === RES_OK) {
      if (res.Result) {
        commit('setBackMenuConfig', res.Result.backMenuConfig || [])
        commit('setBackPageConfig', res.Result.backPageConfig || [])
        commit('setFrontPageConfig', res.Result.frontPageConfig || [])
        commit('setBusinessMpPageConfig', res.Result.businessMpPageConfig || [])
      } else {
        commit('setBackMenuConfig', [])
        commit('setBackPageConfig', [])
        commit('setFrontPageConfig', [])
        commit('setBusinessMpPageConfig', [])
      }
    }
  },
  //  品牌列表
  async doGetBrandList({ commit, state, dispatch }) {
    const param = {
      companyId: state.userInfo.companyId
    }
    const res = await getBrandListApi(param)
    if (res && res.Code === RES_OK) {
      const list = res.Result || []
      commit('setBrandList', list)
      if (list.length) {
        await dispatch('getBrandById', list[0].id)
        dispatch('doGetShopListAction')
      } else {
        hasBrand = false
      }
    }
  },
  //  品牌详情
  async getBrandById({ state, getters, commit, dispatch }, brandId) {
    const param = {
      id: brandId
    }
    if (state.userInfo.hierarchyType === 'JT') {
      await dispatch('getGroupByIdAction', state.userInfo.groupId)
      return
    }
    const res = await getBrandByIdApi(param)
    if (res.Code === RES_OK) {
      const brandInfo = res.Result || {}
      functionAuthMap = generatorMap(brandInfo.functionAuth, 'type', false)
      commit('setBrandInfo', brandInfo)
      let isOpenGxms = getters.isOpenGxms
      if (!isOpenGxms) {
        await dispatch('doGetShopListAction')
      } else {
        await dispatch('doGetShareShopListAction')
        // dispatch('getCustomChargeItemListAction')
      }
    }
  },
  async getBrandByIdAction({ commit }, brandId) {
    const param = {
      id: brandId
    }
    const res = await getBrandByIdApi(param)
    if (res.Code === RES_OK) {
      const brandInfo = res.Result || {}
      commit('setBrandInfo', brandInfo)
    }
  },
  async getGroupByIdAction({ commit, state, dispatch }, groupId) {
    const param = {
      id: groupId
    }
    const res = await getGroupByIdApi(param)
    if (res.Code === RES_OK) {
      let obj = res.Result || {}
      commit('setGroupInfo', obj)
    }
  },
  //  门店列表
  async doGetShopListAction({ commit, state, dispatch }) {
    const param = {
      brandId: state.brandInfo.id
      //  COMPANY_ID: '0EA75D3948B64DF08DE182261AFBE4CF'
    }
    const res = await getShopListApi(param)
    if (res.Code === RES_OK) {
      const list = res.Result || []
      await dispatch('doGetRoleById', list)
      // commit('setShopList', list)
      // commit('setShopInfo', list[0])
    }
  },
  async doGetShopById({ commit, state, dispatch }, id) {
    const param = {
      id: id
    }
    const res = await getShopByIdApi(param)
    if (res.Code === RES_OK) {
      let obj = res.Result
      commit('setShopInfo', obj)
    }
  },
  //  高校共享门店列表
  async doGetShareShopListAction({ commit, state, dispatch }) {
    const param = {
      companyId: state.companyInfo.id,
      relBrandId: state.brandInfo.id
      //  COMPANY_ID: '0EA75D3948B64DF08DE182261AFBE4CF'
    }
    const res = await getShareShopListApi(param)
    if (res.Code === RES_OK) {
      const list = res.Result || []
      await dispatch('doGetRoleById', list)
      // commit('setShopList', list)
      // commit('setShopInfo', list[0])
    }
  },
  async doGetRoleById({ getters, commit, dispatch }, list) {
    let param = {}
    param.id = getters.userInfo.roleId
    const res = await getRoleByIdApi(param)
    if (res.Code === RES_OK) {
      commit('setRoleInfo', res.Result)
      commit('setAllShopList', list)
      if (res.Result.isHaveOperableShopLimit === '0') {
        if (getters.isOpenGxms) {
          commit('setShopList', list)
        } else {
          commit(
            'setShopList',
            list.filter(info => info.shopType === '1' || info.shopType === '4')
          )
        }
        // commit('setShopInfo', list[0])
        if (getters.userInfo.hierarchyType === 'MD') {
          dispatch('doGetShopById', getters.userInfo.shopId)
        } else {
          if (list.length > 0) {
            dispatch('doGetShopById', list[0].id)
          }
        }
      } else {
        let roleOperableShopList = res.Result.roleOperableShopList
        let shopList = []
        roleOperableShopList.forEach(info => {
          if (
            list.some(
              shop =>
                shop.id === info.shopId &&
                (shop.shopType === '1' || info.shopType === '4')
            )
          ) {
            shopList.push(
              list.find(
                temp =>
                  temp.id === info.shopId &&
                  (temp.shopType === '1' || info.shopType === '4')
              )
            )
          }
        })
        commit('setShopList', shopList)
        if (shopList.length > 0) {
          // commit('setShopInfo', shopList[0])
          // dispatch('doGetShopById', list[0].id)
          if (getters.userInfo.hierarchyType === 'MD') {
            dispatch('doGetShopById', getters.userInfo.shopId)
          } else {
            dispatch('doGetShopById', list[0].id)
          }
        }
      }
      if (getters.isOpenGxms && getters.hierarchyType === 'MD') {
        if (list.some(info => info.id === getters.userShopId)) {
          let obj = list.find(info => info.id === getters.userShopId)
          if (!isEmpty(obj.groupId) && obj.groupApplyState === '2') {
            await dispatch('getGroupByIdAction', obj.groupId)
          } else {
            commit('setGroupInfo', { payType: '2' })
          }
        }
      }
    }
  },
  async queryAgentCompany({ getters, commit }) {
    let param = {}
    param.agentCompanyId = getters.companyId
    param.pageIndex = 1
    param.pageSize = 100
    param.curState = '1,2,3,4'
    const res = await queryAgentCompanyApi(param)
    if (res.Code === RES_OK) {
      commit('setAgentCompanyList', res.Result)
    }
  },
  async doQueryAccountOutAction({ getters, commit }) {
    let param = {}
    param.relationId = getters.companyId
    param.pageIndex = 1
    param.pageSize = 10
    param.accountType = '1'
    param.mchMode = '1'
    const res = await queryAccountOutApi(param)
    if (res.Code === RES_OK) {
      if (res.Result) {
        let list = res.Result.list || []
        commit('setCompnayAccountList', list)
      }
    }
  }
}
export default actions
